import { Stack, TextField, Typography } from '@mui/material';
import { ChangeEvent, useContext, useState } from 'react';
import { MTDialog } from '@/components/common/MTDialog';
import { COMMON_STRING } from '@/constants/dictionary';
import { ActionDialogProps } from '@/components/ActionsDialog/types';
import { CommentButtons } from '@/components/Comment/CommentButtons';
import { ScoringContext } from '@/contexts/scoring/context';
import { generateSubTitleDialog } from '@/utils/dialogSubTitle/generateSubTitleDialog';
import { TEXT_FIELD_CONSTANCE } from '../ActionEvaluationDialog/constants';
import { TextFieldCharactersCounter } from '../common/TextFieldCharactersCounter';

export const CommentDialog = ({ action, onClose }: ActionDialogProps) => {
  const { comment } = action;
  const {
    state: { commentChanged, actionTypesCurrentSport },
  } = useContext(ScoringContext);

  const currentOriginalComment = comment ?? '';

  const [commentSetted, setComment] = useState<string>(currentOriginalComment);

  const [commentWhenOpened, setCommentWhenOpened] = useState(
    currentOriginalComment,
  );

  const didLocalCommentChange = () => {
    const actionComment = currentOriginalComment;
    const newComment = commentSetted;
    return actionComment !== newComment;
  };
  const didOriginalCommentChange = () => {
    return (
      commentWhenOpened !== currentOriginalComment ||
      !!(
        commentChanged &&
        commentChanged.fixtureActionId === action.id &&
        commentChanged.comment !== currentOriginalComment
      )
    );
  };
  const syncOriginalComment = () => {
    setCommentWhenOpened(currentOriginalComment);
    setComment(currentOriginalComment);
  };

  return (
    <MTDialog
      open={true}
      onClose={onClose}
      title={COMMON_STRING.ACTION_COMMENT}
      maxWidth='sm'
      fullWidth
      sx={{ justifyContent: 'left' }}
    >
      <Stack gap={2} width='100%'>
        <Stack flexDirection='row' gap={0.5}>
          <Typography variant='subtitle2'>
            {generateSubTitleDialog({ action, actionTypesCurrentSport })}
          </Typography>
        </Stack>
        <TextField
          id='comment'
          multiline
          value={commentSetted}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            if (
              event.target.value.length <= TEXT_FIELD_CONSTANCE.CHARACTERS_LIMIT
            ) {
              setComment(event.target.value);
            }
          }}
          minRows={6}
          maxRows={16}
          inputProps={{
            maxLength: TEXT_FIELD_CONSTANCE.CHARACTERS_LIMIT,
          }}
        />
        <TextFieldCharactersCounter text={commentSetted} />
        <CommentButtons
          hasLocalChanges={didLocalCommentChange()}
          hasRemoteChanges={didOriginalCommentChange()}
          onSyncClick={() => syncOriginalComment()}
          action={action}
          onClose={onClose}
          comment={commentSetted}
        />
      </Stack>
    </MTDialog>
  );
};
